import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";

/**
 * Sticky bottom CTA — mobile only. Appears after the user scrolls past the
 * hero (~600px). Used on /websites and /revenue-systems pages.
 */
export default function StickyMobileCTA({ label, onClick, testId }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid={testId || "sticky-mobile-cta"}
      aria-hidden={!visible}
      className={`lg:hidden fixed inset-x-0 bottom-0 z-40 px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 transition-all duration-300 ${
        visible
          ? "translate-y-0 opacity-100 pointer-events-auto"
          : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <div className="max-w-md mx-auto rounded-full bg-[#070706] shadow-[0_18px_40px_-12px_rgba(0,0,0,0.35)]">
        <button
          type="button"
          onClick={onClick}
          className="w-full inline-flex items-center justify-center gap-2 rounded-full text-[#F4F0E8] px-6 py-3.5 text-[15px] font-medium min-h-[52px]"
          data-testid={`${testId || "sticky-mobile-cta"}-btn`}
        >
          {label}
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
}
